import React, { memo } from 'react';
import { useBridgeAPI, useBridgeState } from '@digitaz/bridge-sdk-client';
import { ensureHTTPProtocolInWebsiteUrl } from '../../../utils/helpers';

interface BridgeLinkProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href?: string;
  children?: React.ReactNode;
}

const BridgeLink: React.FC<BridgeLinkProps> = memo(
  ({ href, children, ...rest }) => {
    const { isWebView } = useBridgeState();
    const { openUrl } = useBridgeAPI();

    const onClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
      if (isWebView && href) {
        e.preventDefault();
        openUrl(ensureHTTPProtocolInWebsiteUrl(href));
      }
    };

    return (
      <a onClick={onClick} href={href} {...rest}>
        {children}
      </a>
    );
  }
);

BridgeLink.displayName = `BridgeLink`;

export default BridgeLink;
